import s from "./AboutMe.module.scss";
import { CLOUDINARY_BASE_URL } from "../config/cloudinary";
import InstagramLogo from "../components/InstagramLogo";
import TiktokLogo from "../components/TiktokLogo";
import { useLanguage } from "../contexts/LanguageContext";
import { aboutMeText } from "../i18n/aboutMe";
import { TIKTOK_URL } from "../config/socialLinks";
import { trackCtaClick } from "../utils/analytics";

const img = (path) => `${CLOUDINARY_BASE_URL}${path}`;
const profileImage =
  "v1782912075/ChatGPT_Image_2026%E5%B9%B47%E6%9C%881%E6%97%A5_22_20_01_1_qimn6n.png";
const REN_INSTAGRAM_URL = "https://www.instagram.com/ren.worldtour";

const AboutMe = () => {
  const { lang } = useLanguage();
  const text = aboutMeText[lang] || aboutMeText.JP;

  return (
    <section className={s.root} id="about-me">
      <img src={img(profileImage)} alt="Ren" className={s.profile} />

      <h3>Ren</h3>

      <p className={s.role}>Videographer / Drone Pilot / Tour Guide</p>

      <p className={s.text}>
        {text.textLines.map((line) => (
          <span key={line}>{line}</span>
        ))}

        <br />

        <span>{text.hobby}</span>
      </p>

      <div className={s.socials}>
        <a
          href={REN_INSTAGRAM_URL}
          target="_blank"
          rel="noreferrer"
          aria-label="Instagram"
          onClick={() =>
            trackCtaClick({
              label: "instagram_about_me",
              placement: "about_me",
              destination: REN_INSTAGRAM_URL,
              destinationType: "external_social",
            })
          }
        >
          <InstagramLogo />
        </a>

        <a
          href={TIKTOK_URL}
          target="_blank"
          rel="noreferrer"
          aria-label="TikTok"
          onClick={() =>
            trackCtaClick({
              label: "tiktok_about_me",
              placement: "about_me",
              destination: TIKTOK_URL,
              destinationType: "external_social",
            })
          }
        >
          <TiktokLogo />
        </a>
      </div>
    </section>
  );
};

export default AboutMe;
